import { render, staticRenderFns } from "./NormalDashboard.vue?vue&type=template&id=26d9c7c8&"
import script from "./NormalDashboard.vue?vue&type=script&lang=js&"
export * from "./NormalDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports